import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CheckIcon } from "./Icons";
const STEPS = ["Matter & documents", "Case theory", "Draft"];
export default function Stepper({ current }) {
    return (_jsx("nav", { className: "steprail", "aria-label": "Progress", children: STEPS.map((label, i) => {
            const n = i + 1;
            const state = n === current ? "active" : n < current ? "done" : "";
            return (_jsxs("div", { style: { display: "contents" }, children: [i > 0 && _jsx("span", { className: `step-sep ${n <= current ? "done" : ""}` }), _jsxs("div", { className: `step ${state}`, "aria-current": n === current ? "step" : undefined, children: [_jsx("span", { className: "num", children: n < current ? _jsx(CheckIcon, { size: 15 }) : n }), _jsx("span", { className: "lbl", children: label })] })] }, label));
        }) }));
}
